uic-check-list {
    display: block;
    box-sizing: border-box;
    height: 100%;
    padding: 0;
    background-color: var(--uic-check-list-background-color);

    .uic-check-list__scrollpanel {
        height: 100%;
    }
}
